
import { Options, Vue } from 'vue-class-component';
import { BottomUnderwearSquareMeterConfigurationClient } from '@/services/Services';
import UploadBottomUnderwearExcelModal from '../modals/uploadBottomUnderwearExcelModal.vue';
import * as OM from '@/Model';

@Options({
    components: {}
})
export default class bottomUnderwearConfig extends Vue {

    configurations: OM.BottomUnderwearSquareMeterCombinationsConfig[] = [];

    created() {
        this.init();
    }

    init() {
        BottomUnderwearSquareMeterConfigurationClient.getConfigurationList()
        .then(x => {
            this.configurations = x;
        })
    }

    uploadExcelModal() {
        this.$opModal.show(UploadBottomUnderwearExcelModal, {
            callback: () => {
                this.$opModal.closeLast();
                this.init();
            }
        })
    }

}
